import React from 'react';
import useStore from '../../../store';
import { PrivilegedContext } from '../../../store/user';

interface PrivilegedUser {
  privileges: string[];
  context?: PrivilegedContext;
}

const WithPrivilegedUser: React.FC<PrivilegedUser> = ({ privileges, context, children }) => {
  const [{ userPrivilegesCache }] = useStore();

  const isVisible = privileges.length
    ? userPrivilegesCache.isPrivileged(privileges, context)
    : true;

  return <div>{isVisible && children}</div>;
};

export default WithPrivilegedUser;
